import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  initials: 'SM',
  name: 'S.M.',
  role: 'Ballet Teacher, London, UK',
  text: 'I used to spend every Sunday night writing out barre combinations and center exercises. Now I open the library, pick the class, and walk in completely prepared. My students feel the difference—and so do I.'
}, {
  initials: 'CV',
  name: 'C.V.',
  role: 'Ballet Instructor, Toronto, Canada',
  text: 'The pre-ballet activities alone were worth the entire price. I teach 3 to 6 year olds three times a week and I was running out of ideas every single month. Now I have 50 activities ready to go.'
}, {
  initials: 'JR',
  name: 'J.R.',
  role: 'Ballet Teacher, Sydney, Australia',
  text: 'The corrections and cueing library changed how I communicate with my students completely. My feedback is clearer, my cues are more professional, and my students understand what I am asking them to do.'
}];
export function TestimonialsStrip() {
  return <section className="border-y border-ballet-line bg-white px-4 py-14" data-id="element-247">
      <div className="mx-auto grid max-w-7xl gap-5 md:grid-cols-3" data-id="element-248">
        {testimonials.map((testimonial, index) => <motion.figure key={testimonial.initials} initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        delay: index * 0.08
      }} className="rounded-2xl border border-ballet-line bg-ballet-canvas p-6 shadow-card" data-id="element-249">
            <div className="mb-4 flex gap-1 text-ballet-gold" aria-label="Five star review" data-id="element-250">
              {Array.from({
            length: 5
          }, (_, star) => <StarIcon key={star} size={15} fill="currentColor" data-id="element-251" />)}
            </div>
            <blockquote className="text-sm leading-6 text-ballet-muted" data-id="element-252">
              “{testimonial.text}”
            </blockquote>
            <figcaption className="mt-6 flex items-center gap-3" data-id="element-253">
              <span className="flex h-10 w-10 items-center justify-center rounded-full border border-ballet-gold/70 bg-ballet-blush text-xs font-bold text-ballet-rose" data-id="element-254">
                {testimonial.initials}
              </span>
              <span data-id="element-255">
                <strong className="block text-sm text-ballet-ink" data-id="element-256">
                  {testimonial.name}
                </strong>
                <span className="block text-xs text-ballet-muted" data-id="element-257">
                  {testimonial.role}
                </span>
              </span>
            </figcaption>
          </motion.figure>)}
      </div>
    </section>;
}